var CONFUSEDCMS = CONFUSEDCMS || {},
    CONFUSEDPETROLPRICES = CONFUSEDPETROLPRICES || {};
CONFUSEDPETROLPRICES.SearchFormValidation = CONFUSEDPETROLPRICES.SearchFormValidation || {};

(function (ns, $) {
    'use strict';

    // html elements
    ns.Elements = {
        SFFuelType: 'input[name=\'sfFuelType\']',
        SFFuelTypeSelected: 'input[name=\'sfFuelType\']:checked',
        SFFuelTypeError: '#sfFuelTypeError',
        SFRadiusError: '#sfRadiusError',
        SFPostcode: '#sfPostcode',
        SFPostcodeErrorEnabled: '#sfPostcodeErrorEnabled',
        SFPostcodeError: '#sfPostcodeError',
        RSFuelType: '#rsFuelType',
        RSFuelTypeSelected: '#rsFuelType option:selected',
        RSFuelTypeError: '#rsFuelTypeError',
        RSRadius: '#rsRadius',
        RSRadiusSelected: '#rsRadius option:selected',
        RSRadiusError: '#rsRadiusError',
        RSPostcode: '#rsPostcode',
        RSPostcodeErrorEnabled: '#rsPostcodeErrorEnabled',
        RSPostcodeError: '#rsPostcodeError'
    };

    // validation constants
    ns.ValidationConstants = {
        FuelTypes: [1, 2, 4, 5, 6, 7],
        Radius: [5, 10, 25],
        PostcodeRegex: '^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) {0,1}[0-9][A-Za-z]{2})$'
    };

    // error message constants
    ns.ErrorMessageConstants = {
        FuelType: 'Please select a fuel type',
        Radius: 'Please enter a valid radius',
        Postcode: 'Please enter a valid postcode'
    };

    // validation methods
    ns.Validation = {
        FuelType: function (fuelType) {
            var parsedFuelType = parseInt(fuelType, 10);
            if (isNaN(parsedFuelType)) {
                return false;
            }
            return (jQuery.inArray(parsedFuelType, ns.ValidationConstants.FuelTypes) !== -1);
        },
        Radius: function (radius) {
            var parsedRadius = parseInt(radius, 10);
            if (isNaN(parsedRadius)) {
                return false;
            }
            return (jQuery.inArray(parsedRadius, ns.ValidationConstants.Radius) !== -1);
        },
        Postcode: function (postcode) {
            var re = new RegExp(ns.ValidationConstants.PostcodeRegex);
            return re.test(postcode);
        },
        MyLocation: function (postcodeLatitude, postcodeLongitude) {
            return postcodeLatitude !== 0 && postcodeLongitude !== 0;
        }
    };

    // bind validation
    CONFUSEDPETROLPRICES.bindValidation = function () {

        // search form: fuel type
        $(ns.Elements.SFFuelType).change(function () {
            CONFUSEDPETROLPRICES.validateSFFuelType($(ns.Elements.SFFuelTypeSelected).val());
        });

        // search form: postcode
        $(ns.Elements.SFPostcode).keyup(function () {
            if ($(ns.Elements.SFPostcodeErrorEnabled).is(':checked')) {
                CONFUSEDPETROLPRICES.validateSFPostcode($(ns.Elements.SFPostcode).val());
            }
        });

        $(ns.Elements.SFPostcode).blur(function () {
            CONFUSEDPETROLPRICES.enablePostcodeError();
            CONFUSEDPETROLPRICES.validateSFPostcode($(ns.Elements.SFPostcode).val());
        });

        // radius search: fuel type
        $(ns.Elements.RSFuelType).change(function () {
            CONFUSEDPETROLPRICES.validateRSFuelType($(ns.Elements.RSFuelTypeSelected).val());
        });

        // radius search: radius
        $(ns.Elements.RSRadius).change(function () {
            CONFUSEDPETROLPRICES.validateRSRadius($(ns.Elements.RSRadiusSelected).val());
        });

        // radius search: postcode
        $(ns.Elements.RSPostcode).keyup(function () {
            if ($(ns.Elements.RSPostcodeErrorEnabled).is(':checked')) {
                CONFUSEDPETROLPRICES.validateRSPostcode($(ns.Elements.RSPostcode).val());
            }
        });

        $(ns.Elements.RSPostcode).blur(function () {
            CONFUSEDPETROLPRICES.enablePostcodeError();
            CONFUSEDPETROLPRICES.validateRSPostcode($(ns.Elements.RSPostcode).val());
        });
    };

    // validate search form
    CONFUSEDPETROLPRICES.validateSearchForm = function (fuelType, radius, postcode, postcodeLatitude, postcodeLongitude) {
        var validFuelType = CONFUSEDPETROLPRICES.validateSFFuelType(fuelType);
        var validRadius = CONFUSEDPETROLPRICES.validateSFRadius(radius);

        var validPostcode;
        if (postcode !== CONFUSEDPETROLPRICES.Constants.MyLocation) {
            validPostcode = CONFUSEDPETROLPRICES.validateSFPostcode(postcode);
        } else {
            validPostcode = CONFUSEDPETROLPRICES.validateSFMyLocation(postcodeLatitude, postcodeLongitude);
        }

        return (validFuelType && validRadius && validPostcode);
    };

    // validate search form: fuel type
    CONFUSEDPETROLPRICES.validateSFFuelType = function (fuelType) {
        return CONFUSEDPETROLPRICES.handleElementValidation(
            ns.Validation.FuelType(fuelType),
            $(ns.Elements.SFFuelTypeError),
            ns.ErrorMessageConstants.FuelType
        );
    };

    // validate search form: radius
    CONFUSEDPETROLPRICES.validateSFRadius = function (radius) {
        return CONFUSEDPETROLPRICES.handleElementValidation(
            ns.Validation.Radius(radius),
            $(ns.Elements.SFRadiusError),
            ns.ErrorMessageConstants.Radius
        );
    };

    // validate search form: postcode
    CONFUSEDPETROLPRICES.validateSFPostcode = function (postcode) {
        return CONFUSEDPETROLPRICES.handleElementValidation(
            ns.Validation.Postcode(postcode),
            $(ns.Elements.SFPostcodeError),
            ns.ErrorMessageConstants.Postcode
        );
    };

    // validate search form: my location
    CONFUSEDPETROLPRICES.validateSFMyLocation = function (postcodeLatitude, postcodeLongitude) {
        return CONFUSEDPETROLPRICES.handleElementValidation(
            ns.Validation.MyLocation(postcodeLatitude, postcodeLongitude),
            $(ns.Elements.SFPostcodeError),
            ns.ErrorMessageConstants.Postcode
        );
    };

    // validate radius search
    CONFUSEDPETROLPRICES.validateRadiusSearch = function (fuelType, radius, postcode, postcodeLatitude, postcodeLongitude) {
        var validFuelType = CONFUSEDPETROLPRICES.validateRSFuelType(fuelType);
        var validRadius = CONFUSEDPETROLPRICES.validateRSRadius(radius);

        var validPostcode;
        if (postcode !== CONFUSEDPETROLPRICES.Constants.MyLocation) {
            validPostcode = CONFUSEDPETROLPRICES.validateRSPostcode(postcode);
        } else {
            validPostcode = CONFUSEDPETROLPRICES.validateRSMyLocation(postcodeLatitude, postcodeLongitude);
        }

        return (validFuelType && validRadius && validPostcode);
    };

    // validate radius search: fuel type
    CONFUSEDPETROLPRICES.validateRSFuelType = function (fuelType) {
        return CONFUSEDPETROLPRICES.handleElementValidation(
            ns.Validation.FuelType(fuelType),
            $(ns.Elements.RSFuelTypeError),
            ns.ErrorMessageConstants.FuelType
        );
    };

    // validate radius search: radius
    CONFUSEDPETROLPRICES.validateRSRadius = function (radius) {
        return CONFUSEDPETROLPRICES.handleElementValidation(
            ns.Validation.Radius(radius),
            $(ns.Elements.RSRadiusError),
            ns.ErrorMessageConstants.Radius
        );
    };

    // validate radius search: postcode
    CONFUSEDPETROLPRICES.validateRSPostcode = function (postcode) {
        return CONFUSEDPETROLPRICES.handleElementValidation(
            ns.Validation.Postcode(postcode),
            $(ns.Elements.RSPostcodeError),
            ns.ErrorMessageConstants.Postcode
        );
    };

    // validate radius search: my location
    CONFUSEDPETROLPRICES.validateRSMyLocation = function (postcodeLatitude, postcodeLongitude) {
        return CONFUSEDPETROLPRICES.handleElementValidation(
            ns.Validation.MyLocation(postcodeLatitude, postcodeLongitude),
            $(ns.Elements.RSPostcodeError),
            ns.ErrorMessageConstants.Postcode
        );
    };

    // handle element validation
    CONFUSEDPETROLPRICES.handleElementValidation = function (isValid, element, errorMessage) {
        if (isValid) {
            element.html('');
            element.hide();
            return true;
        }

        element.html(errorMessage);
        element.show();
        return false;
    };

    // enable postcode error
    CONFUSEDPETROLPRICES.enablePostcodeError = function () {
        $(ns.Elements.SFPostcodeErrorEnabled).prop('checked', true);
        $(ns.Elements.RSPostcodeErrorEnabled).prop('checked', true);
    };

    // disbale postcode error
    CONFUSEDPETROLPRICES.disablePostcodeError = function () {
        $(ns.Elements.SFPostcodeErrorEnabled).prop('checked', false);
        $(ns.Elements.RSPostcodeErrorEnabled).prop('checked', false);
    };

}(CONFUSEDPETROLPRICES.SearchFormValidation, jQuery));